import PropTypes from 'prop-types';

const ValuesType = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
]);

export const ConditionShape = PropTypes.shape({
    clientId: PropTypes.string,
    dimension: PropTypes.string,
    operator: PropTypes.string,
    customFieldName: PropTypes.string,
    values: ValuesType,
    invalid: PropTypes.bool,
});

export const RuleShape = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    action: PropTypes.number,
    active: PropTypes.bool,
    dirty: PropTypes.bool,
    generated: PropTypes.bool,
    placeUnder: PropTypes.number,
    updated: PropTypes.number,
    updated_by: PropTypes.string,
    last_update_by_singular: PropTypes.bool,
    picture: PropTypes.string,
    invalidName: PropTypes.bool,
    conditions: PropTypes.arrayOf(ConditionShape),
});

const OptionListShape = PropTypes.arrayOf(
    PropTypes.shape({
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    })
);

export const ConditionOptionsShape = PropTypes.shape({
    betaHiddenFlags: PropTypes.objectOf(PropTypes.bool),
    sources: OptionListShape,
    apps: OptionListShape,
    countries: OptionListShape,
    regions: OptionListShape,
    cities: OptionListShape,
    installSourceBundles: OptionListShape,
});

export const EditingShape = PropTypes.objectOf(RuleShape);

export const ActionsShape = PropTypes.shape({
    conditionOptions: ConditionOptionsShape,
    toggleEdit: PropTypes.func,
    cancelEdit: PropTypes.func,
    search: PropTypes.func,
    onSort: PropTypes.func,
    newRule: PropTypes.func,
    editRule: PropTypes.func,
    addCondition: PropTypes.func,
    editCondition: PropTypes.func,
    removeCondition: PropTypes.func,
    save: PropTypes.func,
    deleteRule: PropTypes.func,
    duplicate: PropTypes.func,
});
